import { requestGet } from '@/common/request';

export default async function marketingPlanDel(query: { marketingPlanCode: string }): Promise<RequestResult<{}>> {
  return await requestGet('/marketingPlan/del', query);
}
